export default __webpack_public_path__ + "static/media/business-22.33e524bb.jpg";